import ProfileImg from "../../assets/used-images/default.jpg";
import Border from "../../assets/images/BorderColor.png";
import { useUserData } from '../../store/UserData';
import ProfileLoading from '../loading/profile';
import { useTranslation } from "react-i18next";

const ProfileInfo = () => {
  const { profile, error, loading } = useUserData();
  const { t } = useTranslation();
  const userData = [
    { title: t('profile.full-name'), data: `${profile?.first_name} ${profile?.last_name}` },
    { title: t('contact.email'), data: profile?.email },
    { title: t('contact.phone'), data: profile?.phone },
    // { title: "تاريخ الميلاد", data: profile?.birthday },
    // { title: "البلد", data: profile?.city },
    { title: "العنوان", data: profile?.company_title },
    { title: "الوظيفة", data: profile?.job_title }
  ];


  if (error) return (
    <div className="h-dvh w-full flex justify-center items-center">
      <p>
        {error}
      </p>
    </div>
  );

  if (loading) return (<ProfileLoading editProfile={false} />)

  return (
    <>
      <section className='flex justify-between items-center max-lg:flex-col py-2 px-3 border rounded-xl bg-[#F5F5F559]'>
        <div className='flex items-center gap-3 flex-wrap justify-content-center'>
          <div className='rounded-full relative p-1'>
            <img src={Border} alt="border" className='w-40 absolute top-0 right-0' />
            <img src={profile?.image ?? ProfileImg} alt={profile?.first_name} className='rounded-full size-32 m-2' />
          </div>
          <div>
            <p className="text-xl !text-start">{profile?.first_name} {profile?.last_name}</p>
            <p className="text-semi-gray">{profile?.email}</p>
          </div>
        </div>
      </section>
      <section className='border py-2 px-3 rounded-xl mt-2 '>
        <h2 className="text-secondary-tw text-xl font-semibold">
          {t('profile.data')}
        </h2>
        <section className='grid grid-cols-3 max-lg:grid-cols-2 gap-2 my-4 max-sm:grid-cols-1'>
          {
            userData.map((item, i) => (
              <div key={i} className='!text-start' >
                <p className="text-semi-gray">
                  {item.title}
                </p>
                <p>
                  {item.data}
                </p>
              </div>
            ))
          }
        </section>
      </section>
    </>
  );
};

export default ProfileInfo;